import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import NotificationList from './notification-list'
import PageTitle from "../../../common/page-title/index";
import ArrowButton from "../../../common/button-arrow";
import {getNotifications} from '../../../../actions/notifications'

import './styles.css'

class Notifications extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount() {
    this.props.dispatch(getNotifications());
  }

  render(){
    return (

      <Grid bsClass="container" fluid className="notifications">
        <PageTitle>Notifications</PageTitle>
        <Link to="/admin/notifications/new">
          <ArrowButton color="red"
                       className="add-notification"
                       arrow={false}
                       submit={false}
                       permissions={{
                         action:       "new",
                         subjectClass: "Notification",
                       }}>Add notification</ArrowButton>
        </Link>

        <NotificationList
          notifications={this.props.notifications}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications.notifications,
    fetched: state.notifications.fetched,
    fetching: state.notifications.fetching,
  };
};


export default connect(mapStateToProps)(Notifications);


// WEBPACK FOOTER //
// ./src/components/admin/notifications/list/index.jsx